import React, {useState, useEffect, useContext, useRef} from 'react';
import useOnClickOutside from "../hooks/useOnClickOutside";
import NavigationDrawer from './NavigationDrawer';
import SeriesSelect from './SeriesSelectDevelopment';
import SeriesNavigation from './SeriesNavigation';
import {UserContext} from '../common/UserContext';
import {MenuCompressButton} from "./CompressButton";
import {TemplateContext} from "../common/TemplateContext";
import NavigationSmallScreenDevelopment from "./NavigationSmallScreenDevelopment";
import {NavigationContext} from "../common/NavigationContext";
import {useScreenMode} from "../common/context/ScreenModeContext";

const NavigationDevelopment = props => {
    const {contextualShortcuts, children} = props;
    const {user, setUser, updateLeftMenuClosed, menuPosition} = useContext(UserContext);
    const {isSeriesNavVisible, setSeriesNavVisible} = useContext(TemplateContext);
    const { isNavVisible, setNavVisible, isDrawerVisible, setDrawerVisible } = useContext(NavigationContext);
    const [drawerComponentName, setDrawerComponentName] = useState(undefined);
    const [isMenuVisible, setMenuVisible] = useState(false);
    const navigationRef = useRef();
    const mainMenuRef = useRef();
    const [ myCourseShortcut, setMyCourseShortcut ] = useState(contextualShortcuts.filter(shortcuts => shortcuts.shortcutId === 2)[0]);
    const [seriesNavKey, setSeriesNavKey] = useState(0);
    const {smallScreenMode, mobileScreenMode} = useScreenMode();

    useEffect(() => {
        if(window.location.href.includes('showNavigation=true')) {
            setSeriesNavVisible(true);
        }
    }, []);

    useEffect(() => {
        if (smallScreenMode) {
            if ((isDrawerVisible || isMenuVisible || isSeriesNavVisible)) {
                setNavVisible(true);
            } else if (isNavVisible) {
                setNavVisible(false);
            }
        } else {
            setNavVisible(true);
        }
    }, [smallScreenMode, isSeriesNavVisible]);

    useEffect(() => {
        // This is to force unmount and remount the component for mobile
        if (isSeriesNavVisible) {
            setSeriesNavKey(prev => prev + 1);
        }
    }, [isSeriesNavVisible]);

    useEffect(() => {
        const nav = document.getElementById('nav');
        const navR = document.getElementById('nav-r');

        const resizeCanvas = () => {
            if (globalReactFunctions !== undefined) {
                if (globalReactFunctions.resizeScorcherCanvas !== undefined) {
                    globalReactFunctions.resizeScorcherCanvas();
                }
                if (globalReactFunctions.resizeWidgetCanvas !== undefined) {
                    globalReactFunctions.resizeWidgetCanvas();
                }
            }
        }

        const navTransitionEnd = () => {
            //resizes scorcher and widget canvas elements
            resizeCanvas();

            //dispatchesEvent global event at end of transition
            window.dispatchEvent(new Event('menuSizeChanged'));
        }

        resizeCanvas();
        nav.addEventListener('transitionend', navTransitionEnd,false);
        navR.addEventListener('transitionend', navTransitionEnd,false);
        return () => {
            nav.removeEventListener('transitionend', navTransitionEnd);
            navR.removeEventListener('transitionend', navTransitionEnd);
        }
    }, [user]);

    if (globalReactFunctions !== undefined) {
        globalReactFunctions.setDrawerVisible = setDrawerVisible;
    }

    useOnClickOutside(navigationRef, isNavVisible, () => {
        if (smallScreenMode) {
            setDrawerVisible(false);
        }
    });

    const handleCloseNavFromMobile = () => {
        setNavVisible(false);
        setDrawerVisible(false);
    }

    if(user.publicSession && user.guideMode) {
        return null;
    }

    return (
        <div ref={navigationRef} className={'ch-nav' + (smallScreenMode ? ' ch-nav-msm' : '') + (!isNavVisible && !isDrawerVisible ? ' ch-nav-hide' : '') + (mobileScreenMode ? ' ch-nav-msm' : '')} id={'leftNav'}>
            <div className={'ch-nav-columns'}>
                {(!user.expired && (!user.publicSession || user.syllabusGroupId)) &&
                    <>
                        {(!smallScreenMode && !mobileScreenMode) && <div className={'ch-nav-contextual ch-nav-column'}>
                            <SeriesSelect
                                className={`ch-nav-contextual-head ${menuPosition.leftMenuClosed ? 'compressed' : ''}`}
                                visible={isSeriesNavVisible} compressed={menuPosition.leftMenuClosed}
                                smallScreenMode={smallScreenMode} onClick={() => {
                                setSeriesNavVisible(!isSeriesNavVisible);
                            }}/>
                            <div
                                className="ch-nav-contextual-body"
                                aria-hidden={isSeriesNavVisible ? 'true' : undefined}
                                inert={isSeriesNavVisible ? '' : undefined}
                            >
                                {children}
                            </div>
                        </div>}
                        <SeriesNavigation visible={isSeriesNavVisible} callback={() => {setSeriesNavVisible(false);}} outsideClickIgnoreClass={'ch-ignore-click-outside'} />
                        <MenuCompressButton aria-controls="leftNav" right={menuPosition.leftMenuClosed} hidden={isSeriesNavVisible || smallScreenMode} onClick={() => {updateLeftMenuClosed(!menuPosition.leftMenuClosed);setSeriesNavVisible(false);}} />
                    </>}
                {smallScreenMode &&
                    <NavigationSmallScreenDevelopment children={children} closeNav={handleCloseNavFromMobile} smallScreenMode={smallScreenMode} isSeriesNavVisible={isSeriesNavVisible} />
                }
            </div>
        </div>
    );
}

export default NavigationDevelopment;